
jQuery(document).ready(function() {
    wowo(jQuery);
    home();
    menu();
    video();
    numbers();
});

jQuery(window).scroll(function() {
    wowo(jQuery);
    numbers();
	sidebar();
 

});


function wowo($) {
    setTimeout(function () {
        jQuery('html').addClass("show-c");
        
        var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
        jQuery(".wowo:not(.animated)").each(function () {
            var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
                    limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
            if (meTop > limitTop && meBottom < limitBottom) {
                me.addClass("animated");
                setTimeout(function () {
                    me.removeClass("animated wowo");
                }, 1500);
            }
        })
    }, 100);
}

function menu(){
	jQuery('.hamburger').click(function(){
		jQuery(this).toggleClass('open');
		jQuery('.head-menu').toggleClass('open');
		jQuery('#head').toggleClass('open');
		if(jQuery('.hamburger').hasClass('open')){
			setTimeout(function(){
				jQuery('.head-logo').addClass('open');
			},800);
		}
		if(!jQuery('.hamburger').hasClass('open')){
			jQuery('body').removeClass('hidden');
			setTimeout(function(){
				jQuery('.head-logo').removeClass('open');
			},1);
			jQuery(".menu .menu-box .menu-box-box .menu-menu .menu-item-has-children .sub-menu").removeClass("open-sub-menu");
		}
		jQuery("header .head-top .head-top-box .form-search").slideToggle(300);
	});
	jQuery(".head-menu .menu .menu-item-has-children>a").append("<span class='icon iconfont icondvmp'></span>");
	jQuery("body").on("click",".head-menu .menu .menu-item-has-children>a .icondvmp",function(e){
		e.preventDefault();
		jQuery(this).parent("a").siblings(".hover-content").slideToggle(300);
		jQuery(this).parents(".menu-item-has-children").toggleClass('is-active');
		jQuery(this).parents(".menu-item-has-children").siblings().children(".hover-content").slideUp(300);
		jQuery(this).parents(".menu-item-has-children").siblings().removeClass('is-active');
		
		jQuery(this).parent("a").siblings(".sub-menu").slideToggle(300);
		jQuery(this).parents(".menu-item-has-children").siblings().children(".sub-menu").slideUp(300);
	});
//	jQuery("header .head-content .head-content-box .head-menu .head-menu-overflow .head-menu-overflow-box .menu li>a").click(function () {
//		jQuery(".hamburger").removeClass('open');
//		jQuery('.head-menu').removeClass('open');
//		jQuery('#head').removeClass('open');
//	});
//	jQuery("header .head-content .head-content-box .head-menu .head-menu-overflow .head-menu-overflow-box .link a").click(function () {
//		jQuery(".hamburger").removeClass('open');
//		jQuery('.head-menu').removeClass('open');
//		jQuery('#head').removeClass('open');
//	});
}

	function video(){
	
		
		jQuery(".video-link.mp4").click(function(event){
		 	console.log("aaa");
			 event.preventDefault();
			 jQuery(document).bind("mousewheel DOMMouseScroll",function(event){event.preventDefault()});
			 jQuery(document).bind("touchmove",function(event){event.preventDefault()});
			 var video_url = jQuery(this).find('.data-video').html();
			 jQuery('.video-light-box').find('.play-iframe-video').append('<video controls="controls"><source src="'+video_url+'" type="video/mp4"></video>');
			 jQuery('.video-light-box').fadeIn(300);
		 });
		 
	
		  jQuery(".video-link.file").click(function(event){
			 event.preventDefault();
			 jQuery(document).bind("mousewheel DOMMouseScroll",function(event){event.preventDefault()});
			 jQuery(document).bind("touchmove",function(event){event.preventDefault()});
			 var video_url = jQuery(this).find('.data-video').html();
			 var caption=jQuery(this).find('.data-video').attr('data-caption');
			 jQuery('.video-light-box').find('.play-iframe-video').append('<video controls="controls"><source src="'+video_url+'" type="video/mp4"> <track src="'+caption+'"  srclang="en" label="English" kind="subtitles" default /></video>');
			 jQuery('.video-light-box').fadeIn(300);
		 });
	
		 jQuery(".video-link.embed").click(function(event){
			 event.preventDefault();
			 jQuery(document).bind("mousewheel DOMMouseScroll",function(event){event.preventDefault()});
			 jQuery(document).bind("touchmove",function(event){event.preventDefault()});
			 jQuery('.video-light-box').fadeIn(300);
			 var html = jQuery(this).find('.data-video').html();
			 
			 jQuery('.video-light-box').find('.play-iframe-video').html(html);
		 });
		 jQuery('.video-light-box .close').click(function(){
			 jQuery(document).unbind("mousewheel DOMMouseScroll");
			 jQuery(document).unbind("touchmove");
			 jQuery('.video-light-box').fadeOut(300);
			 setTimeout(function(){
					 jQuery('.video-light-box').find('.play-iframe-video').html('');
			 },300);
		 });
		 jQuery('.video-light-box').click(function(){
			 jQuery(document).unbind("mousewheel DOMMouseScroll");
			 jQuery(document).unbind("touchmove");
			 jQuery('.video-light-box').fadeOut(300);
			 setTimeout(function(){
					 jQuery('.video-light-box').find('.play-iframe-video').html('');
			 },300);
		 });
		 jQuery('.video-light-box .video-box').click(function(event){
			 event.stopPropagation();
		 });
		 
		 jQuery(".video-link").click(function(event){
		 	event.stopPropagation();
	    	setTimeout(function(){
	    		var ss=jQuery(".video-light-box .video-box video");
	    		ss.trigger('play');
	    	},300);
		 });
		 

	 }


function home() {
	
	

	
	
    if (jQuery('.testimonials-slider').length > 0) {
		jQuery('.testimonials-slider').slick({
			dots: false,
			arrows: true,
			infinite: false,
			fade: true,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 6000,
		});
	}
    if (jQuery('.japan-banner').length > 0) {
		jQuery('.japan-banner').slick({
			dots: true,
			arrows: false,
			infinite: false,
			fade: true,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 6000,
		});
	}
    if (jQuery('.text-and-image-w-cta-slider').length > 0) {
		jQuery('.text-and-image-w-cta-slider').slick({
			dots: false,
			arrows: true,
			infinite: false,
			fade: true,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 6000,
		});
	}
    
    
	if (jQuery('.three-item-slider-box').length > 0) {
		jQuery('.three-item-slider-box').slick({
			dots: false,
			arrows: true,
			infinite: false,
			fade: false,
			speed: 800,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 6000,
			draggable:true,
			swipe:true,
			swipeToSlide:true,
			responsive: [
				{
					breakpoint: 768.1,
					settings: {
						slidesToShow: 2,
				
					}
				},
				{
					breakpoint: 556.1,
					settings: {
						slidesToShow: 1,
						
					}
				},
			]
		});
	}
	
	jQuery("header .head-top .head-top-box .right .head-search a").click(function(e){
		e.preventDefault();
		jQuery("header .head-top .head-top-box .form-search").addClass("is-active");
		
	});
	jQuery("body").click(function(e){
		e.stopPropagation();
		jQuery("header .head-top .head-top-box .form-search").removeClass("is-active");
	});
	jQuery("header .head-top").click(function(e){
		e.stopPropagation();
	});
	
	
	jQuery(".blog-list .filter-c .filter-c-box .form-group").click(function(e){
		e.stopPropagation();
		jQuery(this).toggleClass("is-active");
		jQuery(this).find("ul").slideToggle(300);
		jQuery(this).siblings().removeClass("is-active");
		jQuery(this).siblings().find("ul").slideUp(300);
	});
	
	
	
	jQuery("body").click(function(e){
		e.stopPropagation();
		jQuery(".filter-c .filter-c-box .form-group").removeClass("is-active");
		jQuery(".filter-c .filter-c-box .form-group").find("ul").slideUp(300);
	});
	
	jQuery(".faqs .content .block .title-faq").click(function(e){
			e.stopPropagation();
			jQuery(this).toggleClass("is-active");
			jQuery(this).siblings(".text-faq").slideToggle(300);
			jQuery(this).parents(".block").siblings().children(".title-faq").removeClass("is-active");
			jQuery(this).parents(".block").siblings().children(".text-faq").slideUp(300);
		});
	
	if(jQuery("body").hasClass("page-template-template-Japan-page")){
		jQuery(".image-and-text .content .text .text-faqs .block .title-faq").click(function(e){
			e.stopPropagation();
			jQuery(this).toggleClass("is-active");
			jQuery(this).siblings(".text-faq").children(".hide-text").slideToggle(300);
			jQuery(this).parents(".block").siblings().children(".title-faq").removeClass("is-active");
			jQuery(this).parents(".block").siblings().children(".text-faq").children(".hide-text").slideUp(300);
		});
	}else{
		
		
		jQuery(".image-and-text .content .text .text-faqs .block .title-faq").click(function(e){
			e.stopPropagation();
			jQuery(this).toggleClass("is-active");
			jQuery(this).siblings(".text-faq").slideToggle(300);
			jQuery(this).parents(".block").siblings().children(".title-faq").removeClass("is-active");
			jQuery(this).parents(".block").siblings().children(".text-faq").slideUp(300);
		});
	}
	
	
	
	
	if (jQuery('.security-products-slider').length > 0) {
		jQuery('.security-products-slider').slick({
			dots: false,
			arrows: true,
			infinite: false,
			fade: false,
			speed: 800,
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 6000,
			draggable:true,
			swipe:true,
			swipeToSlide:true,
			responsive: [
				{
					breakpoint: 556.1,
					settings: {
						
						slidesToShow: 1,
						
					}
				},
			]
		});
	}
	
	if (jQuery('.partners-slider').length > 0) {
		jQuery('.partners-slider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			fade: false,
			speed: 800,
			slidesToShow: 7,
			slidesToScroll: 1,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 4000,

			responsive: [
				{
					breakpoint: 1400.1,
					settings: {
						
						slidesToShow: 6,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 768.1,
					settings: {
						
						slidesToShow: 5,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 556.1,
					settings: {
						
						slidesToShow: 4,
						slidesToScroll: 1,
					}
				},
			]
		});
	}
	
	if (jQuery('.right-slider-box').length > 0) {
		jQuery('.right-slider-box').slick({
			dots: false,
			arrows: true,
			infinite: false,
			fade: false,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 6000,
		});
	}
	
	if (jQuery('.products-text-images-slider').length > 0) {
		jQuery('.products-text-images-slider').slick({
			dots: true,
			arrows: true,
			infinite: false,
			fade: false,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 6000,
			draggable:true,
			swipe:true,
			swipeToSlide:true,
		});
	}
	if (jQuery('.teams-slider').length > 0) {
		jQuery('.teams-slider').slick({
			dots: false,
			arrows: true,
			infinite: false,
			fade: false,
			speed: 800,
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 6000,
			draggable:true,
			swipe:true,
			swipeToSlide:true,
			responsive: [
				{
					breakpoint: 992.1,
					settings: {
						slidesToShow: 3,
				
					}
				},
				{
					breakpoint: 768.1,
					settings: {
						slidesToShow: 2,
				
					}
				},
				{
					breakpoint: 556.1,
					settings: {
						slidesToShow: 1,
						
					}
				},
			]
		});
	}
	if (jQuery('.partners-slider-two').length > 0) {
		jQuery('.partners-slider-two').slick({
			dots: false,
			arrows: false,
			infinite: true,
			fade: false,
			speed: 800,
			slidesToShow: 6,
			slidesToScroll: 1,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 4000,
			responsive: [
				{
					breakpoint: 1400.1,
					settings: {
						
						slidesToShow: 5,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 992.1,
					settings: {
						
						slidesToShow: 4,
						slidesToScroll: 1,
					}
				},
//				{
//					breakpoint: 768.1,
//					settings: {
//						
//						slidesToShow: 3,
//						slidesToScroll: 3,
//					}
//				},
//				{
//					breakpoint: 556.1,
//					settings: {
//						
//						slidesToShow: 2,
//						slidesToScroll: 2,
//					}
//				},
			]
		});
	}
	if (jQuery('.security-products-slider-two').length > 0) {
		jQuery('.security-products-slider-two').slick({
			dots: false,
			arrows: true,
			infinite: false,
			fade: false,
			speed: 800,
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 6000,
			draggable:true,
			swipe:true,
			swipeToSlide:true,
			responsive: [
				{
					breakpoint: 1430.1,
					settings: {
						
						slidesToShow: 3,
						
					}
				},
				{
					breakpoint: 992.1,
					settings: {
						
						slidesToShow: 2,
						
					}
				},
				{
					breakpoint: 556.1,
					settings: {
						
						slidesToShow: 1,
						
					}
				},
			]
		});
	}
	
	
	function resize_slider(){
		if (jQuery('.image-and-text-table-slider').length > 0) {
			jQuery('.image-and-text-table-slider').each(function() {
				var slidesToShow = parseInt(jQuery(this).attr("data-slidesToShow")) || 3;
				jQuery(this).slick({
					dots: false,
					arrows: true,
					infinite: false,
					fade: false,
					speed: 800,
					slidesToShow: slidesToShow,
					slidesToScroll: 1,
					autoplay: false,
					pauseOnHover: false,
					autoplaySpeed: 6000,
					draggable:true,
					swipe:true,
					swipeToSlide:true,
				});
			});
			
		}
	}
	
	
	if (window.innerWidth > 992.5) {
		if (!jQuery('.image-and-text-table-slider').hasClass('slick-initialized')) {
			resize_slider();
		}
	} else {
		if (jQuery('.image-and-text-table-slider').hasClass('slick-initialized')) {
			jQuery('.image-and-text-table-slider').slick('unslick');
		}
	}
	jQuery(window).resize(function(e) {
		if (window.innerWidth > 992.5) {
		if (!jQuery('.image-and-text-table-slider').hasClass('slick-initialized')) {
			resize_slider();
		}
	} else {
		if (jQuery('.image-and-text-table-slider').hasClass('slick-initialized')) {
			jQuery('.image-and-text-table-slider').slick('unslick');
		}
	}
	});
	
	
	jQuery(".image-and-text .title .title-item .item a").click(function(event){
		event.preventDefault();
		var index=jQuery(this).parents(".item").index();
		jQuery(this).parents(".item").addClass("is-active");
		jQuery(this).parents(".item").siblings().removeClass("is-active");
		jQuery(".image-and-text.title-show .content-list .content").eq(index).addClass("is-active");
		jQuery(".image-and-text.title-show .content-list .content").eq(index).siblings().removeClass("is-active");
	});
	jQuery(".resources-list .filter-c .filter-c-box .video-content i").click(function(event){
		event.preventDefault();
		jQuery(this).parents(".video-content").toggleClass("is-active");

	});
	
	
	jQuery(".resources-list .filter-c .filter-c-box .form-group").click(function(e){
		e.stopPropagation();
		jQuery(this).toggleClass("is-active");
		jQuery(this).find("ul").slideToggle(300);
		jQuery(this).siblings(".form-group").removeClass("is-active");
		jQuery(this).siblings(".form-group").find("ul").slideUp(300);
	});
	



	
	var zong22=0;
	jQuery(".events-list .content .content-box .old-events .block").each(function(){
		zong22++;
	});
	jQuery(".event-load-more").click(function(event){
		event.preventDefault();
		
		var data_type=jQuery(this).attr("data-type");

			var a_this=jQuery(this);
			var data_number=jQuery(this).attr("data-number");
			var dangqian=parseInt(data_number) + 9;
			var i=0;
			var ii=0;
			jQuery(".events-list .content .content-box .old-events .block").each(function(){
				var this_c=jQuery(this);
				i++;
				if(i <= dangqian){
					 ii++;
					setTimeout(function(){
						this_c.fadeIn(200);
						
						if(ii >= zong22){
							jQuery(".event-load-more").fadeOut(200);
						}
						a_this.attr("data-number",dangqian);
					},400);
					
				}
				
				
			});
	});
	
	var zong=0;
	jQuery(".news-list .content .stories-box .block").each(function(){
		zong++;
	});
	jQuery(".news-load-more").click(function(event){
		event.preventDefault();
			var a_this=jQuery(this);
			var data_number=jQuery(this).attr("data-number");
			var dangqian=parseInt(data_number) + 9;
			var i=0;
			var ii=0;
			
			jQuery(".news-list .content .stories-box .block").each(function(){
				var this_c=jQuery(this);
				i++;
				if(i <= dangqian){
					 ii++;
				
					setTimeout(function(){
						this_c.fadeIn(200);
						
						if(ii >= zong){
							jQuery(".news-load-more").fadeOut(200);
						}
						a_this.attr("data-number",dangqian);
					},400);
					
				}
				
				
				
			});
	});
	
	jQuery(".our-location .content .links .link a").click(function(event){
		event.preventDefault();
		jQuery(this).addClass("is-active");
		jQuery(this).parents(".link").siblings().children("a").removeClass("is-active");
		var inex=jQuery(this).parents(".link").index();
		jQuery(".our-location .content .text-and-map").removeClass("is-active");
		jQuery(".our-location .content .text-and-map").eq(inex).addClass("is-active");

	});
	jQuery(".content-w-tabbed-cards .content .right .tab-title span").click(function(event){
		var inde=jQuery(this).index();
		jQuery(this).addClass("is-active");
		jQuery(this).siblings().removeClass("is-active");
		jQuery(".content-w-tabbed-cards .content .right .tab-content .tab-box").eq(inde).addClass("is-active");
		jQuery(".content-w-tabbed-cards .content .right .tab-content .tab-box").eq(inde).siblings().removeClass("is-active");

	});
	
	
	if(jQuery(".banner.form-banner-box .form-c").length > 0){
		jQuery("a").click(function(event){
			var href_c=jQuery(this).attr("href");
			if(href_c == "#free-trial"){
				event.preventDefault();
				
				jQuery('body,html').animate({scrollTop:0},600);
			}
		});
	}
	
	if(jQuery("#japan-page").length > 0){
		jQuery("a").click(function(event){
			var this_c=jQuery(this);
			var href_c=jQuery(this).attr("href");
			if(href_c == "#book-now-click"){
			
				event.preventDefault();
				this_c.parents(".image-and-text").find(".modale").addClass("opened");
				
			}
		});
	}
//	jQuery(".search-box .content .left .filter-search .items .item span").click(function(event){
//		event.preventDefault();
//		var this_text=jQuery(this).text();
//		
//		jQuery(this).parents(".item").addClass("is-active");
//		jQuery(this).parents(".item").siblings().removeClass("is-active");
//		
//		
//		jQuery(".search-box .content .right .search-item .item").removeClass("is-show");
//		
//		var index=jQuery(this).parents(".item").index();
//		
//		jQuery(".search-box .content .right .search-item").addClass("is-active");
//		setTimeout(function(){
//			jQuery(".search-box .content .right .search-item").removeClass("is-active");
//			jQuery(".search-box .content .right .search-item .item").removeClass("is-active");
//			jQuery(".search-box .content .right .search-item .item").eq(index).addClass("is-active");
//		},400);
//		
//		jQuery(".search-box .link a").attr("data-number","3");
//		if(this_text == "All"){
//			jQuery(".search-box .link a").attr("data-type","all");
//		}else{
//			jQuery(".search-box .link a").attr("data-type","index");
//			
////			setTimeout(function(){
////				jQuery(".search-box .content .right .search-item .item").addClass("is-none-block");
////			},400);
////			jQuery(".search-box .content .right .search-item .item").removeClass("is-none");
////			jQuery(".search-box .content .right .search-item .item").removeClass("is-show");
////			jQuery(".search-box .content .right .search-item .item").removeClass("is-show-a");
////			
////				jQuery(".search-box .content .right .search-item .item").addClass("is-none");
////		
////				jQuery(".search-box .content .right .search-item .item").eq(index).removeClass("is-none");
////				//setTimeout(function(){
////				jQuery(".search-box .content .right .search-item .item").eq(index).addClass("is-show");
////				//},400);
////				setTimeout(function(){
////				jQuery(".search-box .content .right .search-item .item").eq(index).addClass("is-show-a");
////				},300);
//		
//		}
//		
//
//	});
//	jQuery(".search-box .link a").click(function(event){
//		event.preventDefault();
//		
//		var data_type=jQuery(this).attr("data-type");
//		if(data_type = "all"){
//			jQuery(".search-box .content .right .search-item .item").addClass("is-show");
//			
//			var a_this=jQuery(this);
//			var data_number=jQuery(this).attr("data-number");
//			var zonng=parseInt(data_number) + 3;
//			var i=0;
//			var ii=0;
//			jQuery(".search-box .content .right .search-item .item .block").each(function(){
//				ii++;
//			});
//			
//			jQuery(".search-box .content .right .search-item .item .block").each(function(){
//				var this_c=jQuery(this);
//				i++;
//				if(i <= zonng){
//					console.log(zonng);
//					console.log(i);
//					this_c.fadeIn(200);
//					if(i>= ii){
//						jQuery(".search-box .link a").fadeOut(200);
//					}
//					
//				}
//				a_this.attr("data-number",zonng);
//				
//			});
//			
//			
//			
//			
//			
//		}else{
//			//jQuery(".search-box .content .right .search-item .item").removeClass("is-show");
//		}
//		
//		
//		
//	});
}


function numbers() {
		
		jQuery(".testimonials-and-percentage .content .right .right-box .block:not(.active) h3 .number").each(function () {
			
		var wTops = jQuery(window).scrollTop(),
            wHeights = jQuery(window).height(),
            wBottoms = wTops + wHeights;
			var this_c=jQuery(this);
            var h=jQuery(this).parents(".testimonials-and-percentage").offset().top;
         
			var ss=wTops + wHeights - 100;
		
			 if (ss > h) {
        
            var me =jQuery(this).parents(".block"),
                meTops = me.offset().top,
                meHeights = me.innerHeight(),
                meBottoms = meTops + meHeights,
                limitTops = wTops - meHeights,
                limitBottoms = wBottoms + meHeights;
                me.addClass("active");
                var num = parseInt(jQuery(this).html());
                jQuery(this).prop('number', 0).animateNumber({
                        number: num,
                    },
                    1000
               );
           }
            
       });
      
	}
	function sidebar() {
		var scrH = jQuery(window).scrollTop();

		
		
		jQuery(".events-detail .content .right").each(function(){
			var this_c=jQuery(this);
			var ct = this_c.offset().top,
				rH = this_c.height(),
				rcH = this_c.height();
			var notop = scrH - ct + 119;
			var vh_h = this_c.parents(".content").height();
			var wHeights = jQuery(window).height();
			
			var scroll_h = 0;
			if (notop < 70) {
				scroll_h = 0;
			} else {
				scroll_h = notop ;
			}
			if (notop + rcH > rH) {
				this_c.children(".scroll-to-follow").css('bottom',"inherit");
				this_c.children(".scroll-to-follow").css('top', scroll_h);
			}
			if (notop > vh_h - this_c.children(".form-box").height()) {
				this_c.children(".scroll-to-follow").css('top', "inherit");
				this_c.children(".scroll-to-follow").css('bottom', 0);
			}
			
			
		});
	}
/*
jQuery animateNumber plugin v0.0.14
(c) 2013, Alexandr Borisov.
https://github.com/aishek/jquery-animateNumber
*/
(function(d) {
    var r = function(b) {
            return b.split("").reverse().join("")
        },
        m = {
            numberStep: function(b, a) {
                var e = Math.floor(b);
                d(a.elem).text(e)
            }
        },
        g = function(b) {
            var a = b.elem;
            a.nodeType && a.parentNode && (a = a._animateNumberSetter, a || (a = m.numberStep), a(b.now, b))
        };
    d.Tween && d.Tween.propHooks ? d.Tween.propHooks.number = {
        set: g
    } : d.fx.step.number = g;
    d.animateNumber = {
        numberStepFactories: {
            append: function(b) {
                return function(a, e) {
                    var f = Math.floor(a);
                    d(e.elem).prop("number", a).text(f + b)
                }
            },
            separator: function(b, a, e) {
                b = b || " ";
                a = a || 3;
                e = e || "";
                return function(f, k) {
                    var u = 0 > f,
                        c = Math.floor((u ? -1 : 1) * f).toString(),
                        n = d(k.elem);
                    if(c.length > a) {
                        for(var h = c, l = a, m = h.split("").reverse(), c = [], p, s, q, t = 0, g = Math.ceil(h.length / l); t < g; t++) {
                            p = "";
                            for(q = 0; q < l; q++) {
                                s = t * l + q;
                                if(s === h.length) break;
                                p += m[s]
                            }
                            c.push(p)
                        }
                        h = c.length - 1;
                        l = r(c[h]);
                        c[h] = r(parseInt(l, 10).toString());
                        c = c.join(b);
                        c = r(c)
                    }
                    n.prop("number", f).text((u ? "-" : "") + c + e)
                }
            }
        }
    };
    d.fn.animateNumber = function() {
        for(var b = arguments[0], a = d.extend({}, m, b), e = d(this), f = [a], k = 1, g = arguments.length; k < g; k++) f.push(arguments[k]);
        if(b.numberStep) {
            var c = this.each(function() {
                    this._animateNumberSetter = b.numberStep
                }),
                n = a.complete;
            a.complete = function() {
                c.each(function() {
                    delete this._animateNumberSetter
                });
                n && n.apply(this, arguments)
            }
        }
        return e.animate.apply(e, f)
    }

})(jQuery);